import { render, staticRenderFns } from "./areaTree.vue?vue&type=template&id=e0f603a2&scoped=true"
import script from "./areaTree.vue?vue&type=script&lang=js"
export * from "./areaTree.vue?vue&type=script&lang=js"
import style0 from "./areaTree.vue?vue&type=style&index=0&id=e0f603a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f603a2",
  null
  
)

export default component.exports